import {
  Box,
  ListItemIcon,
  ListItem,
  ListItemButton,
  ListItemText,
  SvgIcon,
  Typography,
  List,
} from "@mui/material";
import { PageSetupHolder, RightSide } from "../SetupPage/style";
import { LeftSide, TrialSetupPage } from "../SetupPage/style";
import { NavbarWrapper } from "../common/Navbar/style";
import { BrightHiveLogo } from "../SetupPage/BrightHiveLogo";
import { ReactComponent as brighthiveImage1 } from "../assets/brighthive-theme/brighthiveImage1.svg";
import brighthiveImage2 from "../assets/homePageImage.png";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export const WelcomePage = () => {
  return (
    <PageSetupHolder className="dark">
      <NavbarWrapper
        className="NavbarWrapper"
        role="banner"
        sx={{
          backgroundColor: "transparent",
          padding: "20px 10px",
        }}
      >
        <BrightHiveLogo />
        <SvgIcon
          className="brighthive-image"
          component={brighthiveImage1}
          viewBox="0 0 1444 314"
        />
      </NavbarWrapper>
      <TrialSetupPage>
        <LeftSide>
          <Box className="trial-setup-form set-password">
            <Box
              textAlign={"center"}
              color={"gray.dark"}
              sx={{
                width: "64px",
                height: "64px",
                backgroundColor: "rgb(201 242 234 / 0.5)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                color: "primary.dark",
              }}
            >
              <TaskAltIcon width={32} height={32} />
            </Box>
            <br />
            <Typography
              variant="h5"
              fontWeight={600}
              textAlign={"center"}
              color={"common.black"}
            >
              Welcome to Brighthive!
            </Typography>
            <br />
            <Typography variant="body3" color={"gray.dark"}>
              <Typography variant="body3" color={"gray.dark"}>
                Your email has been successfully verified, and we’ve started
                creating your workspace. You’ll receive an email within the next
                2 business days once your workspace is ready, so you can
                officially start your free trial. In the meantime, feel free to
                explore these resources to learn more about Brighthive and get a
                head start:
                <br />
                <br />
              </Typography>

              <List
                sx={{
                  padding: "0px",
                  margin: "0px",
                  li: {
                    marginBottom: "10px",
                    color: "primary.dark",
                    fontSize: "14px !important",
                  },
                  a: {
                    textDecoration: "none",
                    color: "gray.dark",
                    fontWeight: "600",
                    border: "1px solid",
                    borderColor: "gray.main",
                    borderRadius: "5px",
                    "&:hover": {
                      color: "primary.dark",
                      backgroundColor: "primary.lighter",
                      borderColor: "primary.dark",
                    },
                  },
                  "*": {
                    fontSize: "15px !important",
                    fontWeight: "500 !important",
                  },
                  ".MuiListItemIcon-root": {
                    minWidth: "30px",
                    fontSize: "20px !important",
                    color: "primary.dark",

                    "*": {
                      fontSize: "20px !important",
                    },
                  },
                }}
              >
                <ListItem disablePadding>
                  <ListItemButton
                    component="a"
                    href="https://docs.brighthive.io/"
                    target="_blank"
                  >
                    <ListItemIcon>
                      <DescriptionOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Brighthive Documentation" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component="a"
                    href="https://support.brighthive.io/"
                    target="_blank"
                  >
                    <ListItemIcon>
                      <HelpOutlineIcon />
                    </ListItemIcon>
                    <ListItemText primary="Brighthive Support" />
                  </ListItemButton>
                </ListItem>
              </List>

              <br />
              <Box
                color={"primary.dark"}
                bgcolor={"primary.light"}
                p={2}
                borderRadius={1}
                sx={{
                  border: "1px solid",
                  borderColor: "primary.main",
                }}
              >
                <Typography variant="body3">
                  <strong>Need help?</strong> If you have any questions, our
                  support team is here to help!
                </Typography>
              </Box>
            </Typography>
          </Box>
        </LeftSide>
        <RightSide>
          <Box>
            <Typography
              variant="h5"
              fontWeight={600}
              textAlign={"center"}
              color={"common.black"}
            >
              You're All Set!
            </Typography>
            <Typography
              variant="body1"
              textAlign={"center"}
              color={"gray.dark"}
            >
              Your workspace is being prepared for an amazing experience
            </Typography>
          </Box>
          <img src={brighthiveImage2} alt="brighthive" />
        </RightSide>
      </TrialSetupPage>
    </PageSetupHolder>
  );
};

export default WelcomePage;
